module.exports = __webpack_public_path__ + "img/appsurl.8758c0f6.png";